

































import Vue from 'vue';
import { RichiedenteList } from '../../types';
import * as richiedenteApi from '../../services/richiedente-api';
import dialogEdit from '@/components/commands/DialogEdit.vue';
import richiedenteEdit from '@/components/commands/RichiedenteEdit.vue';
import validationRules from '../mixin/validation-rules';

export default Vue.extend({
    components: { dialogEdit },
    data() {
        return {
            items: [] as RichiedenteList[],
            selectedValue: null as any,
            disabled: false as boolean,
            editComponent: richiedenteEdit,
            dialog: false as boolean,
        };
    },
    props: {
        multiple: { default: false },
        label: { required: true, type: String },
        itemText: { default: 'displayName' },
        itemValue: { default: 'id' },
        clearable: { default: false },
        setDefault: { default: false },
        value: {},
        canAdd: { default: false },
        required: { default: false },
    },
    computed: {
        validationRules(): any[] {
            return this.required
                ? [validationRules.getRequiredRule(this.label)]
                : [];
        },
    },
    methods: {
        onChange(e: any) {
            this.$emit('input', e);
        },
        async loadItems() {
            this.items = await richiedenteApi.getList();
            if (
                this.setDefault &&
                this.items.length > 0 &&
                !this.selectedValue
            ) {
                this.selectedValue = this.multiple
                    ? [this.items[0].id]
                    : this.items[0].id;
                this.onChange(this.selectedValue);
            }
            if (
                (!this.multiple &&
                    this.items.filter((item) => item.id === this.selectedValue)
                        .length === 0) ||
                (this.multiple &&
                    this.selectedValue &&
                    this.selectedValue.length > 0 &&
                    (this.selectedValue as any[]).filter(
                        (selected) =>
                            this.items.filter((item) => item.id === selected)
                                .length > 0
                    ).length === 0)
            ) {
                this.selectedValue = null;
                this.onChange(this.selectedValue);
            }
            this.disabled = false;
        },
        dialogClose() {
            this.dialog = false;
        },
        onSave(e: RichiedenteList) {
            this.items.push(e);
            if (!this.multiple) {
                this.selectedValue = e.id;
            } else {
                if (!this.selectedValue) this.selectedValue = [];
                this.selectedValue.push(e.id);
            }
            this.onChange(this.selectedValue);
        },
    },
    async created() {
        await this.loadItems();
    },
    watch: {
        value: {
            handler: function (val) {
                this.selectedValue = val;
            },
            immediate: true,
        },
    },
});
